/** Strings of the profile pages. */
export const ca_profile = {
  profileUi: {
    configure: 'Configura-ho',
    passwordYes: 'Contrasenya: sí',
    passwordNo: 'Contrasenya: no',
    colMission: 'Missió',
    colWorld: 'Mapa',
    colSide: 'Bàndol',
    colTime: 'Temps jugat',
    colDate: 'Data',
    report: 'Informe',
    playedEmpty: 'Encara no hi ha cap partida en què hagis sortit a la llista de jugadors.',
    sessionsPlayedEmpty: 'Encara no consta que hagis jugat cap sessió de la plataforma.',
    directedEmpty: 'No ha dirigit cap sessió.',
    madeEmpty: 'Encara no ha fet cap missió ni campanya.',
    medalsEmpty: 'Cap medalla encara. S’aconsegueixen a les campanyes.',
    historyEmpty: 'Cap activitat registrada encara.',
    medalsGrouped: 'Per campanya',
    missionKind: 'Missió',
  },
};
